import { z } from 'zod';
const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
// Only http(s) URLs: blocks javascript:/data: schemes; the photo feeds the public
// landing + JSON-LD (defense in depth alongside output escaping).
const imageUrl = z
    .string()
    .url()
    .max(2000)
    .refine((v) => /^https?:\/\//i.test(v), 'La URL debe empezar por http:// o https://');
// Mirrors the real `approved_students` table: an approved record always links to a
// real student (student_id, NOT NULL UNIQUE) and caches landing-facing fields with
// privacy in mind (only the surname initial is stored — last_name_initial).
export const createApprovedStudentSchema = z.object({
    student_id: z.string().uuid(),
    opposition_id: z.string().uuid(),
    first_name: z.string().min(1).max(100),
    last_name_initial: z.string().min(1).max(10),
    opposition_name: z.string().min(1).max(200),
    passed_date: z.string().regex(dateRegex, 'Formato: YYYY-MM-DD'),
    destination: z.string().max(300).optional(),
    photo_url: imageUrl.optional(),
    testimonial: z.string().max(2000).optional(),
    is_visible: z.boolean().default(true),
});
export const updateApprovedStudentSchema = z.object({
    first_name: z.string().min(1).max(100).optional(),
    last_name_initial: z.string().min(1).max(10).optional(),
    opposition_id: z.string().uuid().optional(),
    opposition_name: z.string().min(1).max(200).optional(),
    passed_date: z.string().regex(dateRegex, 'Formato: YYYY-MM-DD').optional(),
    destination: z.string().max(300).nullable().optional(),
    photo_url: imageUrl.nullable().optional(),
    testimonial: z.string().max(2000).nullable().optional(),
    is_visible: z.boolean().optional(),
});
//# sourceMappingURL=approved-student.schema.js.map